import React from 'react';
import { Link } from 'react-router-dom';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#parameters
const SIGN_DISPLAY = {
  AUTO: 'auto',
  NEVER: 'never',
  ALWAYS: 'always',
  EXCEPT_ZERO: 'exceptZero'
};

function formatNumber(num, maximumFractionDigits, minimumFractionDigits, signDisplay) {
  const formatOptions = {
    maximumFractionDigits: !maximumFractionDigits && maximumFractionDigits !== 0 ? 2 : maximumFractionDigits,
    minimumFractionDigits: !minimumFractionDigits && minimumFractionDigits !== 0 ? 2 : minimumFractionDigits,
    signDisplay
  };
  return Intl.NumberFormat('en-US', formatOptions).format(num);
}

export const formatDifferentialHeader = value => (
  <div className="structure-modeling__stat">
    <div>{value}</div>
    <div className="structure-modeling__differential">{'vs. existing'}</div>
  </div>
);

export const formatDifferentialCell = value => {
  const difference = value.proposed - value.current;
  return (
    <div className="structure-modeling__stat">
      <div>{formatNumber(value.proposed, value.digits, value.digits, SIGN_DISPLAY.AUTO)}</div>
      {value.type !== 'new' ? (
        <div className="structure-modeling__differential">
          {formatNumber(difference, value.digits, value.digits, SIGN_DISPLAY.EXCEPT_ZERO)}
        </div>
      ) : null}
    </div>
  );
};

export const formatModelNameCell = value => {
  const STRUCTURES_URL = `/iframe/merit-${window.app.subsite}/structures/struc/structures`;
  return (
    <Link
      title={value.modelName}
      to={{
        pathname: STRUCTURES_URL,
        search: `?model_id=${value.modelId}`,
        state: { fromStructureModeling: true }
      }}
    >
      {value.modelName}
    </Link>
  );
};

export const formatDateCell = value => {
  const dateOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  };
  return new Date(value).toLocaleDateString('en-US', dateOptions);
}
